const schedule = [
  {
    date: "08th March 2026",
    time: null,
    event: "Registration Starts",
    description: "The registration for the ITS-A-Hack is open",
  },
  {
    date: "28th March 2026",
    time: "11:59 PM",
    event: "Registration Ends",
    description: "The Registration Period for ITS-A-Hack will end.",
  },
  {
    date: "02nd April 2026",
    time: "5:00 PM",
    event: "Problem Statement Release",
    description:
      "Problem Statements will be released on the Discord Server and the Website.",
  },
  // {
  //   date: "03 March 2026",
  //   time: "07:00 PM",
  //   event: "Session by Chris Dias",
  //   description:
  //     "Session on 'Regression Model with Azure Machine Learning Designer' by Chris Dias.",
  // },
  {
    date: "03rd April 2026",
    time: "07:00 PM",
    event: "Introductory Session on Discord",
    description:
      "There will be a introductory session on Discord. Join our Discord server for the same. Link will be mailed to accepted team.",
  },
  {
    date: "03rd April 2026",
    time: "08:00 PM",
    event: "ITS-A-Hack Begins!",
    description: "The Hackathon officially commences. Lasting 48 hours",
  },
  {
    date: "04th April 2026",
    time: "12:01 AM",
    event: "Compulsory Mentoring Round",
    description:
      "Mandatory mentoring round where participants will receive guidance and feedback from mentors.",
  },
  {
    date: "04th April 2026",
    time: "08:00 PM",
    event: "Initial Evaluation",
    description:
      "Evaluation Round 1 will take place. Participants will be judged on the progress made so far.",
  },
  {
    date: "05th April 2026",
    time: "10:30 AM",
    event: "Mid Evaluation Round",
    description:
      "Top 4 Teams will be selected to proceed to the Final Evaluation Round",
  },
  {
    date: "05th April 2026",
    time: "6:30 PM",
    event: "Final Evaluation Round",
    description:
      "Top 3 winners will be evaluated by the judges based on their final submissions. This round will determine the ultimate winners of ITS-A-Hack.",
  },
  {
    date: "06th April 2026",
    time: null,
    event: "Announcing Winners",
    description: "The Winners will be announced on the Website and Discord Server.",
  },
];
export default schedule;
